(() => {
  const showMedia = (section, id) => {
    if (!id || !section.querySelector(`[data-product-media="${id}"]`)) return;
    section.querySelectorAll('[data-product-media]').forEach(media => {
      const active = media.dataset.productMedia === String(id);
      media.hidden = !active;
      if (!active) media.querySelectorAll('video').forEach(video => video.pause());
    });
    section.querySelectorAll('[data-gallery-target]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === String(id)));
    });
  };
  document.querySelectorAll('[data-product-section]').forEach(section => {
    section.querySelectorAll('[data-gallery-target]').forEach(button => {
      button.addEventListener('click', () => showMedia(section, button.dataset.galleryTarget));
    });
    const select = section.querySelector('[data-variant-select]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const price = section.querySelector('[data-product-price]');
    const updateVariant = (updateUrl) => {
      const variant = select?.selectedOptions[0];
      if (!variant || !addButton) return;
      const available = variant.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.replaceChildren(document.createTextNode(available ? addButton.dataset.addLabel : addButton.dataset.soldLabel));
      if (price) {
        price.replaceChildren(document.createTextNode(variant.dataset.price));
        if (variant.dataset.comparePrice) {
          const previous = document.createElement('s');
          previous.textContent = variant.dataset.comparePrice;
          price.append(document.createTextNode(' '), previous);
        }
      }
      showMedia(section, variant.dataset.mediaId);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.history.replaceState({}, '', url);
      }
    };
    select?.addEventListener('change', () => updateVariant(true));
    updateVariant(false);
  });
  document.querySelectorAll('[data-localization-select]').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.querySelectorAll('.mobile-menu-panel a').forEach(link => {
    link.addEventListener('click', () => { link.closest('details').open = false; });
  });
})();
